import { render, staticRenderFns } from "./work-menu-item.vue?vue&type=template&id=308e957a"
import script from "./work-menu-item.vue?vue&type=script&lang=ts"
export * from "./work-menu-item.vue?vue&type=script&lang=ts"
import style0 from "./work-menu-item.vue?vue&type=style&index=0&id=308e957a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports